import React from 'react';
import ThreePlane from '../3d/ThreePlane';
import ChatButton from '../ui/ChatButton';
import ScoreCounter from '../ui/ScoreCounter';

const ThreeSection: React.FC = () => {
  return (
    <section id="threejs-section" className="relative overflow-hidden min-h-[300vh] bg-transparent">
      {/* 3D Plane - full width container */}
      <div className="absolute inset-0 z-10">
        <ThreePlane />
      </div>
      
      {/* Chat and Score components positioned within this section */}
      <ChatButton />
      <ScoreCounter />
    </section>
  );
};

export default ThreeSection; 